import localDB from "./localDB";

let GLOBAL = require('./globals');

const TableData = {
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/branch-office-admin-tables`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/tables/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    update(data, res) {
        fetch(`${GLOBAL.BASE_URL}api/tables/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => {
            res(responseData);
        }).catch((err) => {
            res({update: false})
        });
    }
};

export default TableData;



// WEBPACK FOOTER //
// ./src/data/TableData.js